export var TeamLiveEmployerRoutes = {
    "?brandId&sidebar": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule",
        "type": "frontend",
        "abstract": true,
        "templateUrl": "../modules/team_schedule/common/views/schedule_layout.html",
        "controller": "ScheduleController",
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "params": {
            "sidebar": {
                dynamic: true
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./shared/team-live_shared.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("./team-live-employer.module.js");
                }
            }
        ],
        "resolve": {
            wfmRedirection: [`$state`, `hUser`, function ($state, hUser) {
                if (hUser.isTopLevelContext()) {
                    Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                }
            }],
            brand: ['TeamScheduleService', `hUser`, function (TeamScheduleService, hUser) {
                if (!hUser.isTopLevelContext()) {
                    TeamScheduleService.getActiveBrand()
                        .then(function (brand) {
                            return brand;
                        });
                }
            }],
            restric: ['hUser', '$state', '$q', 'userPermissions', function (hUser, $state, $q, userPermissions) {

                var defer = $q.defer();

                userPermissions.getBrandPolicy(hUser.getUserContext().brand_id)
                    .then(function(policyParser) {
                        var hasAccessToTeam = policyParser.hasAccess(userPermissions.ACCESS_TYPES.TEAM);
                        if (hUser.data && hUser.data.user && hUser.data.user.services && !hUser.isTeamSchedulingEnabled() && !hasAccessToTeam) {
                            defer.reject();
                        } else {
                            defer.resolve();
                        }
                    });

                return defer.promise;
            }]
        },
        "onExit": ['localize', function (localize) {
            $('body').removeClass('schedule-body');
            localize.enableLocale();
        }],
        "onEnter": ['hUser', '$state', 'localize', function (hUser, $state, localize) {
            $('body').addClass('schedule-body');
            localize.disableLocale();
        }]
    },
};